/* Stable 2-line clamp for product-card titles (incl. recommendations) */
(function () {
  var LH = 1.5;                // line-height
  var LINES = 2;
  var MAXH = (LH * LINES) + 'em';

  var TITLE_SEL = [
    '.m-product-title', '.m-card__title', '.card__heading', '.m-card-title',
    '.m-product-title a', '.m-card__title a', '.card__heading a', '.m-card-title a',
    '[class*="product-title"]', '[class*="card__title"]', '[class*="heading"]',
    'h3 a','h3','h2 a','h2'
  ].join(',');

  var CARD_ROOTS = [
    '.m-product-card', '.product-card',
    '.m-related-products .m-product-card',
    '.m-recommendations .m-product-card',
    '[id*="product-recommendations"] .m-product-card',
    '.m-recently-viewed .m-product-card',
    '.m-recently-viewed-products .m-product-card',
    '[id*="recently-viewed"] .m-product-card'
  ].join(',');

  function clampIn(root) {
    root.querySelectorAll(CARD_ROOTS).forEach(function (card) {
      var t = card.querySelector(TITLE_SEL);
      if (!t) return;
      t.style.display = '-webkit-box';
      t.style.webkitBoxOrient = 'vertical';
      t.style.webkitLineClamp = String(LINES);
      t.style.overflow = 'hidden';
      t.style.textOverflow = 'ellipsis';
      t.style.lineHeight = LH;
      t.style.minHeight = MAXH;
      t.style.maxHeight = MAXH;
    });
  }

  function clampAll() { clampIn(document); }

  /* ---- Run timings: ngay khi DOM xong + nhiều nhịp sau load để bắt lazy render ---- */
  document.addEventListener('DOMContentLoaded', clampAll);
  window.addEventListener('load', function () {
    clampAll();
    var delays = [100, 300, 800, 1500, 2500]; // backoff nhịp
    delays.forEach(function (d) { setTimeout(clampAll, d); });
  });

  /* ---- Shopify section events (khi recommendations được render lại) ---- */
  document.addEventListener('shopify:section:load', function (e) { clampIn(e.target); });
  document.addEventListener('shopify:section:select', function (e) { clampIn(e.target); });
  // Một số theme phát sinh event khác
  document.addEventListener('product:recommendations:rendered', clampAll);
  document.addEventListener('recommendations:loaded', clampAll);

  /* ---- Quan sát DOM: nếu block recommendations/recently-viewed được chèn trễ ---- */
  try {
    var mo = new MutationObserver(function (muts) {
      var hit = muts.some(function (m) {
        return Array.from(m.addedNodes || []).some(function (n) {
          return n.nodeType === 1 && (
            (n.matches && n.matches('[id*="product-recommendations"], .m-recommendations, [id*="recently-viewed"], .m-recently-viewed, .m-recently-viewed-products'))
            || (n.closest && (n.closest('[id*="product-recommendations"], .m-recommendations, [id*="recently-viewed"], .m-recently-viewed, .m-recently-viewed-products')))
          );
        });
      });
      if (hit) clampAll();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
